import React, { useState, useEffect } from 'react';
import { getAllProjects } from '../services/projectService';
// import { openSourceProjects } from '../data/openSourceProjects'; // Deprecated static data
import ProjectCard from '../components/ProjectCard';
import ProposalModal from '../components/ProposalModal';
import { FaGithub, FaCode, FaLaptopCode, FaPlus } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { useAlertContext } from '../context/AlertContext';

const OpenSourceProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user } = useAuth();
  const { showAlert } = useAlertContext();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const data = await getAllProjects();
        if (data.success) {
            setProjects(data.data);
        }
      } catch (err) {
        console.error('Failed to fetch projects', err);
        // Optionally fallback to static data or show error
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  const handleOpenModal = () => {
      if (!user) {
          showAlert({ type: 'error', message: 'Please login to submit a proposal.' });
          return;
      }
      setIsModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-[#f3f4f6]" style={{
        backgroundImage: `
          radial-gradient(at 0% 0%, rgba(59, 130, 246, 0.15) 0px, transparent 50%),
          radial-gradient(at 100% 0%, rgba(139, 92, 246, 0.15) 0px, transparent 50%),
          radial-gradient(at 100% 100%, rgba(236, 72, 153, 0.15) 0px, transparent 50%),
          radial-gradient(at 0% 100%, rgba(34, 197, 94, 0.15) 0px, transparent 50%)
        `
      }}>
       {/* Top Decoration */}
       <div className="h-[40rem]  bg-gradient-to-r from-gray-900 via-slate-800 to-gray-900 w-full absolute top-0 z-0 rounded-b-[3rem] shadow-lg overflow-hidden">
         <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
         {/* Abstract shapes */}
         <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
             <div className="absolute top-10 left-10 w-64 h-64 bg-primary-500/20 rounded-full blur-3xl"></div>
             <div className="absolute bottom-10 right-10 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"></div>
         </div>
      </div>

      <div className="container-responsive relative z-10 pt-24 px-4 sm:px-6 lg:px-8 pb-12">
        
        {/* Header */}
        <div className="text-center mb-16">
            <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-md border border-white/20 text-blue-200 rounded-full text-sm font-medium mb-6 shadow-lg">
               <FaCode className="w-4 h-4 mr-2" />
               Contribute & Grow
            </div>
            <h1 className="heading-primary mb-6 text-white drop-shadow-lg tracking-tight">
               Open Source <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Projects</span>
            </h1>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed font-light">
               Explore projects, contribute code, and collaborate with the Gaplify community to build the future of career development.
            </p>
        </div>

        {/* Projects Grid */}
        {loading ? (
             <div className="flex justify-center py-20">
                 <div className="loading-spinner w-12 h-12 border-4 border-white border-t-transparent"></div>
             </div>
        ) : projects.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {projects.map(project => (
                    <ProjectCard key={project.id || project._id} project={project} />
                ))}
            </div>
        ) : (
            <div className="text-center py-20 bg-white/10 backdrop-blur-md rounded-3xl border border-white/20 text-white">
                <h3 className="text-2xl font-bold mb-2">No projects found</h3>
                <p className="text-gray-300">Be the first to submit a project proposal!</p>
            </div>
        )}

        {/* Call to Action */}
        <div className="mt-20 bg-white/90 backdrop-blur-md rounded-3xl p-10 border border-white/50 shadow-xl text-center relative overflow-hidden">
             <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-green-100 to-emerald-100 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3"></div>
             <div className="relative z-10">
                 <div className="w-16 h-16 bg-green-100 text-green-600 rounded-2xl flex items-center justify-center text-3xl mx-auto mb-6">
                     <FaLaptopCode />
                 </div>
                 <h2 className="heading-secondary text-gray-900 mb-4">Have a project idea?</h2>
                 <p className="text-gray-600 max-w-xl mx-auto mb-8">
                     We are always looking for new ideas to improve our ecosystem. If you have a tool or library that fits Gaplify, let us know!
                 </p>
                 <button 
                    onClick={handleOpenModal}
                    className="px-8 py-3 bg-gray-900 text-white rounded-xl font-bold hover:bg-black transition-all shadow-lg flex items-center mx-auto"
                 >
                     <FaPlus className="mr-2" /> Submit Proposal
                 </button>
             </div>
        </div>

      </div>

      <ProposalModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default OpenSourceProjects;
